<script setup lang="ts">
import Avatar from "~/components/dumb/Avatar.vue";
import EntityPreviewTooltip from "~/components/dumb/EntityPreviewTooltip.vue";
import UserLink from "~/components/dumb/UserLink.vue";
import type { User } from "~/shared/types";
import { getUserDisplayName } from "~/utils/user";

defineProps<{
  user?: User;
}>();
</script>

<template>
  <EntityPreviewTooltip :user-duid="user?.duid" class="inline-flex">
    <UserLink :user="user" no-underline class="group/user-link flex items-center gap-1">
      <Avatar :user="user" class="icon-sm" />
      <span class="group-hover/user-link:underline">
        <slot>{{ user ? getUserDisplayName(user) : "" }}</slot>
      </span>
    </UserLink>
  </EntityPreviewTooltip>
</template>
